import PostContext from "common-components/dist/common/components/Post/context";

export default PostContext;
